import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
  buttons: {
    height: 44,
    letterSpacing: 1.25,
    fontSize: 16,
    fontWeight: '500',
    borderRadius: '4px',
    padding: theme.spacing(1),
    minWidth: '40%',
    margin: '0 auto',
    marginBottom: theme.spacing(1.25),
    marginTop: theme.spacing(1.25),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.down('lg')]: {
      fontSize: 11
    }
  },
  root: {
    minWidth: '95vw',
    minHeight: '95vh',
    backgroundColor: 'rgba(0, 0, 0, 0.6)'
  },
  outlined: {
    borderColor: theme.palette.common.white,
    background: theme.palette.common.white,
    fontWeight: '500',
    '&:hover': {
      borderColor: theme.palette.common.white,
      background: '#F1F1F4',
      opacity: 0.8
    },
    '&:focus': {
      borderColor: theme.palette.common.white,
      background: '#F1F1F4',
      opacity: 0.8
    }
  },
  label: {
    borderColor: '#bdbdbd',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    '&:hover': {
      borderColor: '#FFFFFF',
      background: theme.palette.primary.dark,
      opacity: 0.8
    },
    '&:focus': {
      borderColor: '#FFFFFF',
      background: theme.palette.primary.dark,
      opacity: 0.8
    }
  },
  header: {
    color: theme.palette.primary.main,
    marginTop: theme.spacing(1),
    '& h2': {
      fontWeight: 400
    }
  },

  field: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing()
  },
  icon: {
    width: '75%',
    height: '75%'
  },
  arrowIcon: {
    width: '20px',
    height: '20px',
    color: '#FFFFFF'
  },
  closeIcon: {
    float: 'right',
    marginTop: '0px',
    width: '20px',
    height: '20px',
    color: '#FFFFFF'
  },
  dialogContent: {
    marginBottom: '16px',
    height: '80vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  dialogActions: {
    display: 'flex'
  },
  document: {
    width: 'auto',
    height: 'auto',
    margin: 'auto',
    marginTop: '0.5rem'
  },
  excelTable: {
    width: '100%',
    height: '100%',
    overflow: 'auto',
    backgroundColor: theme.palette.background.paper,
    fontFamily: theme.typography.fontFamily,
    padding: theme.spacing(2),
    '& table': {
      borderCollapse: 'collapse',
      width: '100%',
      backgroundColor: theme.palette.background.paper,
      '& th, & td': {
        border: '1px solid #ddd',
        padding: '8px',
        textAlign: 'left',
        backgroundColor: theme.palette.background.paper
      },
      '& th': {
        backgroundColor: theme.palette.grey[100],
        fontWeight: 'bold'
      },
      '& tr': {
        backgroundColor: theme.palette.background.paper
      },
      '& tr:nth-child(even)': {
        backgroundColor: theme.palette.grey[50]
      },
      '& tr:first-child td': {
        fontWeight: 'bold'
      }
    }
  },
  excelWrapper: {
    width: '100%',
    borderRadius: 4,
    overflow: 'hidden',
    boxShadow: '0 2px 12px rgba(0,0,0,0.12)'
  },
  excelTitleBanner: {
    backgroundColor: '#1e3a5f',
    color: theme.palette.common.white,
    padding: theme.spacing(1.5, 3),
    textAlign: 'center',
    fontWeight: '600',
    fontSize: '0.9rem',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    fontFamily: theme.typography.fontFamily
  },
  headerCell: {
    backgroundColor: '#1e3a5f',
    color: theme.palette.common.white,
    fontWeight: '600',
    fontSize: '0.78rem',
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    padding: '10px 16px',
    fontFamily: theme.typography.fontFamily,
    borderBottom: 'none'
  },
  excelDataCell: {
    fontSize: '0.83rem',
    padding: theme.spacing(1.25, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily
  }
}));
